module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-panel-container', {
    class: [_vm.noBorder ? 'no-border' : '']
  }, [_c('c-panel-title', [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df9b730c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-title-line/index.vue
// module id = 1075
// module chunks = 2